/* eslint-disable no-console */

import { $, $$ } from '../helpers/selectors';
import a11yFocusTrap from 'Helpers/focusTrap.js';
import hideElements from 'Helpers/hideElements.js';
import Card from './Card';

class Search {
  constructor() {
    const body = $('body');
    const fasSearch = $$('.search-form');
    const searchOverlay = $('.search-form--overlay');
    const searchResultForm = $('.search-form--results');
    const searchButtonClass = $('.search-form__submit');
    const searchModalClose = $('.search-form__close');
    const menuSearch = $('.js-search-overlay');
    const searchVerticalFilters = $$('.vertical-list__item-button');
    const searchPageNumbers = $$('.page--search .page-numbers');
    let searchSortItems = $$('.hub-filter__sort-item');
    let searchTypesCheckbox = $$('.facetwp-checkbox');
    let isScrollDisabled = false;
    let lastRecordedScroll = 0;

    if (! fasSearch) {
      return false;
    }

    // Disable the scrolling
    const disableScroll = () => {
      if (! isScrollDisabled && typeof document !== 'undefined' && document.body) {
        const bounds = document.body.getBoundingClientRect();
        isScrollDisabled = true;
        // save the current scroll position
        lastRecordedScroll = -(bounds.top) || 0;

        // set the styling of body to a fixed position
        // and its top position to the `this.lastRecordedScroll` value
        document.body.style.position = 'fixed';
        document.body.style.top = `-${ lastRecordedScroll }px`;
        document.body.style.width = '100vw';
        document.body.style.overflow = 'hidden';
      }
    };
    // Enable the scrolling
    // Reset the styling set by the `disableScroll()` function
    const enableScroll = () => {
      if (typeof document !== 'undefined' && document.body && typeof window !== 'undefined') {
        if (isScrollDisabled) {
          isScrollDisabled = false;
          const lastBodyScroll = $('.admin-bar') ? (lastRecordedScroll + 46) : lastRecordedScroll;
          // reset the styling of the body
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          // scroll to the saved position
          window.scrollTo(0, lastBodyScroll);
        }
      }
    };

    const formdata = new FormData();
    if ($('#_wpnonce')) {
      formdata.append('_wpnonce', $('#_wpnonce').getAttribute('value'));
    }
    formdata.append('action', 'facet_apply_filter');

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
    };

    // Mutation Observer - Check for attribute change
    const overlayCallback = function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          if (searchOverlay.classList.contains('is-visible')) {
            a11yFocusTrap.trapFocus(searchOverlay, document.activeElement);
            hideElements('.main', true);
            handlePopularLinkClick();
          }
        }
      }
    };
    const searchOverlayObserver = new MutationObserver(overlayCallback);
    searchOverlay && searchOverlayObserver.observe(searchOverlay, { attributes: true });

    // Search Form Input
    fasSearch.forEach(search => {
      // const searchForm = $('.search-form__form', search);
      const searchInput = $('.search-form__input', search);
      const searchValue = searchInput.getAttribute('value');
      const suggestListing = $('.ep-autosuggest', search);
      const autoSuggestContainer = $('.search-form__autosuggest', search);
      const newSuggestContainer = $('.search-form__suggestions', search);

      searchValue && search.classList.add('has-value');

      search.addEventListener('submit', () => {
        window.dataLayer.push({
          event: 'search',
          eventType: 'site search',
          searchTerms: searchInput.value,
        });
      });

      // Add Event Listener
      searchInput.addEventListener('keyup', e => {
        // Add timeout to reduce trigger upon keyup
        setTimeout(() => {
          if (e.target.value === '') {
            search.classList.remove('has-value');

            displayAutoSuggestedResults(false);
          } else {
            search.classList.add('has-value');
            sessionStorage.setItem('search_term', e.target.value);
          }
        }, 300);
      });

      // Mutation Observer - Check for auto-suggestions items
      const autoSuggestCallback = function(mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes') {
            if (mutation.target.style.display === 'block') {
              const suggestions = $('ul', mutation.target).children;

              displayAutoSuggestedResults(true, suggestions);
            } else {
              displayAutoSuggestedResults(false);
            }
          }
        }
      };
      const autoSuggestObserver = new MutationObserver(autoSuggestCallback);
      autoSuggestObserver.observe(suggestListing, { attributes: true });

      function displayAutoSuggestedResults(show, list) {
        newSuggestContainer.innerHTML = '';

        if (show && list.length > 0) {
          autoSuggestContainer.classList.add('has-suggestions');
          newSuggestContainer.appendChild(handleSort(list));
          handleAutosuggestLinkClick();
        } else {
          autoSuggestContainer.classList.remove('has-suggestions');
        }
      }

      function handleAutosuggestLinkClick() {
        const links = newSuggestContainer.querySelectorAll('.autosuggest-link');

        links.forEach(link => {
          link.addEventListener('click', e => {
            e.preventDefault();

            const value = link.getAttribute('data-search');
            searchInput.value = value;

            displayAutoSuggestedResults(false);
          });
        });
      }
    });

    // Modal Close Button
    if (searchModalClose) {
      searchModalClose.addEventListener('click', () => {
        const searchInput = $('.search-form__input', searchOverlay);
        const autoSuggestContainer = $('.search-form__autosuggest', searchOverlay);
        const newSuggestContainer = $('.search-form__suggestions', searchOverlay);

        searchOverlay.setAttribute('aria-hidden', 'true');
        searchOverlay.classList.remove('is-visible');
        searchOverlay.classList.remove('has-value');

        a11yFocusTrap.unTrapFocus();
        body.classList.remove('overflow-hidden');
        hideElements('.main', false);

        searchButtonClass.focus();
        enableScroll();

        searchInput.value = '';
        autoSuggestContainer.classList.remove('has-suggestions');
        newSuggestContainer.innerHTML = '';
      });
    }

    if (searchResultForm) {
      // Search Verticals
      searchVerticalFilters.forEach(vertical => {
        enableVerticalsEventListener(vertical);
      });

      // Search Sort
      searchSortItems.forEach(sort => {
        enableSortItemsEventListener(sort);
      });

      // Search Types Checkboxes
      searchTypesCheckbox.forEach(checkbox => {
        enableSearchTypesCheckboxEventListener(checkbox);
      });
    }

    if (searchPageNumbers) {
      searchPageNumbers.forEach(page => {
        page.addEventListener('click', e => {
          e.preventDefault();
          fetchData(e.target.href);
        });
      });
    }

    if (menuSearch) {
      menuSearch.addEventListener('click', handleOpenSearchOverlay);
    }

    function getData(data) {
      const parser = new DOMParser();
      const htmlData = parser.parseFromString(data.content, 'text/html').body;

      const resultContainer = $('.hub-result');
      const filterSearchContainer = $('.hub-filter__search');
      const filterVerticalsContainer = $('.hub-filter__verticals');
      const filterSelectionsContainer = $('.hub-filter__selections');
      const searchSortContainer = $('.hub-filter__sort-container');
      const filterClearButton = $('.filter-clear ');
      const searchPagination = $('.hub-pager');

      // Insert Search Result
      resultContainer.innerHTML = '';
      resultContainer.appendChild(htmlData.querySelector('.hub-result').cloneNode(true));

      // Insert Search Verticals
      filterVerticalsContainer.innerHTML = '';
      filterVerticalsContainer.appendChild(htmlData.querySelector('.hub-filter__verticals').cloneNode(true));

      const searchVerticalButtons = $$('.vertical-list__item-button', filterVerticalsContainer);
      searchVerticalButtons.forEach(vertical => {
        enableVerticalsEventListener(vertical);
      });

      // Insert Filter Types Options
      filterSearchContainer.innerHTML = '';
      filterSearchContainer.appendChild(htmlData.querySelector('.hub-filter__search').cloneNode(true));

      // Insert Sort Options
      searchSortContainer.innerHTML = '';
      searchSortContainer.innerHTML = htmlData.querySelector('.hub-filter__sort-container').innerHTML;

      // Insert Filter Clear Button
      const newFilterClearButton = htmlData.querySelector('.filter-clear');
      filterSelectionsContainer.replaceChild(newFilterClearButton, filterClearButton);
      newFilterClearButton.addEventListener('click', e => {
        e.preventDefault();
        fetchData(e.target.getAttribute('href'));

        const currentSort = $('.hub-filter__sort-button span');

        setTimeout(() => {
          currentSort.innerHTML = 'Relevance';
        }, 300);
      });

      // Insert Filter Types Selections
      //// Remove existing selected search types
      const filterTypesContainer = filterSelectionsContainer.querySelector('.filter-selections');
      if (filterTypesContainer) {
        filterSelectionsContainer.removeChild(filterTypesContainer);
      }
      if (htmlData.querySelector('.filter-selections')) {
        filterSelectionsContainer.insertBefore(htmlData.querySelector('.filter-selections').cloneNode(true), filterSelectionsContainer.querySelector('.filter-clear'));
        enableSelectionsEventListener();
      }

      // Re-enable Card Hovers
      enableCardHover();

      // Re-enable Filter Types Checkboxes Listener
      searchTypesCheckbox = $$('.facetwp-checkbox');
      searchTypesCheckbox.forEach(checkbox => {
        enableSearchTypesCheckboxEventListener(checkbox);
      });

      // Re-enable Sort Items Listener
      searchSortItems = $$('.hub-filter__sort-item');
      searchSortItems.forEach(sort => {
        enableSortItemsEventListener(sort);
      });

      if (htmlData.querySelector('.pagination')) {
        searchPagination.innerHTML = '';
        searchPagination.appendChild(htmlData.querySelector('.pagination').cloneNode(true));
        enablePagination();
      } else {
        searchPagination.innerHTML = '';
      }
    }

    function enablePagination() {
      const searchPagination = $('.hub-pager');
      $$('.pagination a', searchPagination).forEach(pgLink => {
        pgLink.addEventListener('click', e => {
          e.preventDefault();
          fetchData(e.target.href);
        });
      });
    }

    function enableCardHover() {
      setTimeout(() => Card(), 250);
    }

    function enableVerticalsEventListener(vertical) {
      vertical.addEventListener('click', e => {
        e.preventDefault();

        const target = e.target;
        const link = target.parentNode.getAttribute('data-href');

        if (target.classList.contains('disabled')) {
          return false;
        }

        fetchData(link);

        target.closest('.verticals-list').querySelector('.checked').classList.remove('checked');
        target.parentNode.classList.add('checked');
      });
    }

    function enableSearchTypesCheckboxEventListener(checkbox) {
      checkbox.addEventListener('click', e => {
        e.preventDefault();

        const target = e.target;
        const link = target.getAttribute('href');

        if (target.classList.contains('disabled')) {
          return false;
        }

        fetchData(link);
      });
    }

    function enableSelectionsEventListener() {
      const selections = $$('.facetwp-selection-value');

      selections.forEach(selection => {
        selection.addEventListener('click', e => {
          e.preventDefault();

          const target = e.target;
          const link = target.getAttribute('href');

          fetchData(link);
        });
      });
    }

    function enableSortItemsEventListener(sort) {
      sort.addEventListener('click', e => {
        e.preventDefault();

        const target = e.target;
        const link = target.getAttribute('data-href');

        if (target.classList.contains('disabled')) {
          return false;
        }

        fetchData(link);

        target.closest('.hub-filter__sort-list').querySelector('.disabled').classList.remove('disabled');
        target.classList.add('disabled');
      });
    }

    function fetchData(link) {
      fetch(link, requestOptions)
        .then(response => response.json())
        .then(result => getData(result))
        .catch(error => console.log('error', error));
    }

    function handlePopularLinkClick() {
      const popularLinksContainer = $('.search-form__popular');
      const searchInput = $('.search-form__input', searchOverlay);
      const links = $$('span', popularLinksContainer);

      links.forEach(link => {
        link.addEventListener('click', e => {
          const value = e.target.innerHTML;
          searchInput.value = value;
          searchOverlay.classList.add('has-value');
        });
      });
    }

    function handleOpenSearchOverlay() {
      const overlay = $('.search-form--overlay');

      body.classList.add('overflow-hidden');
      overlay.classList.add('is-visible');

      disableScroll();
    }

    function handleSort(list) {
      // Sort items by set weights
      // 1. Search Term is exact match and at index 0
      // 2. Search Term is not at index 0
      // 3. Search Term index is not found
      // Sort order by set
      // Flatten sets
      // Return items

      const term = sessionStorage.getItem('search_term');
      const itemSets = [[], [], []];

      // Sort Weights
      list.forEach(item => {
        const itemValue = item.querySelector('.autosuggest-link').getAttribute('data-search').toLowerCase();
        const itemValueIndex = itemValue.indexOf(term.toLowerCase());

        if (itemValueIndex === 0) {
          itemSets[ 0 ].push(item);
          return;
        }

        if (itemValueIndex > 0) {
          itemSets[ 1 ].push(item);
          return;
        }

        if (itemValueIndex === -1) {
          itemSets[ 2 ].push(item);
        }
      });

      // Sort Order
      itemSets.forEach(set => {
        set.sort((a, b) => {
          const aa = a.querySelector('.autosuggest-link').getAttribute('data-search').toLowerCase();
          const bb = b.querySelector('.autosuggest-link').getAttribute('data-search').toLowerCase();

          return aa > bb ? 1 : bb > aa ? -1 : 0; // eslint-disable-line no-nested-ternary
        });
      });

      // Flatten and return
      const frag = document.createDocumentFragment();
      itemSets.flat().forEach(s => frag.appendChild(s));

      return frag;
    }
  }
}

export default Search;
